
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import LogElement from "@/components/logs/LogElement.vue";
import {Getter} from "vuex-class";
import { ROWS_PER_PAGE } from "@/utils/constants";

@Component({
    components: {
        LogElement,
    },
})
export default class LogTable extends Vue {
    @Prop({default: null})
    public logs: {
        count: number,
        rows: any[],
        types: string[],
    };

    @Prop({default: false})
    public loading?: boolean;

    @Getter private isAdmin: boolean;
    @Getter private isMobile: boolean;

    private displayFilter: boolean = false;
    private pagination: any = {
        select: [],
        page: 1,
        itemsPerPage: 10,
    };
    private headers: any[] = [];
    private displayDatePicker: boolean = false;
    private dates: [string, string] = [null, null];
    private MAX_PERIOD_IN_DAYS = 8;

    private ROWS_PER_PAGE = ROWS_PER_PAGE;

    get lang(): string {
        return this.$root.$i18n.locale;
    }

    get currentDay(): string {
        return (new Date()).toISOString();
    }

    get start(): string {
        return this.dates[0];
    }

    get end(): string {
        return this.dates[1];
    }

    get params(): any {
        // Add one day to the end date to get logs from this day
        const endDate: Date = new Date(this.end);
        endDate.setDate(endDate.getDate() + 1);
        return {
            ...this.pagination,
            start: this.start,
            end: endDate.toISOString().substring(0, 10),
        };
    }

    get dateRangeText(): string {
        const formattedStart: string = this.$options.filters.formatShortDate(this.start) || "?";
        const formattedEnd: string = this.$options.filters.formatShortDate(this.end) || "?";
        return this.start === this.end
            ? formattedStart
            : `${formattedStart} - ${formattedEnd}`;
    }

    get isPeriodTooLong(): boolean {
        if (!this.start || !this.end) {
            return false;
        }
        const period: number = (new Date(this.end)).getTime() - (new Date(this.start)).getTime();
        const days: number = Math.ceil(period / (1000 * 60 * 60 * 24));
        return days >= this.MAX_PERIOD_IN_DAYS;
    }

    @Watch("pagination", { deep: true })
    public handler() {
        if (this.logs) {
            this.$emit("get-logs", this.params);
        }
    }

    private mounted(): void {
        this.headers = [
            {value: "createdAt", text: this.$t("logs.createdAt"), sortable: true},
            {value: "data", text: this.$tc("logs.data"), sortable: false},
        ];
        const now: Date = new Date();
        const oneWeekBefore: Date = new Date();
        oneWeekBefore.setDate(now.getDate() - 7);
        this.dates = [
            oneWeekBefore.toISOString().substring(0, 10),
            now.toISOString().substring(0, 10),
        ];
        if (this.isAdmin) {
            this.headers.unshift({value: "type", text: this.$tc("logs.type"), sortable: false});
        }
    }

    private loadLogs(): void {
        if (this.loading === false) {
            this.$emit("get-logs", this.params);
        }
    }

    private changeDates(): void {
        // Throw query if both dates are selected
        if (this.start && this.end) {
            // Reverse dates if the user selected end before start
            if (this.start > this.end) {
                this.dates.reverse();
            }
            if (!this.isPeriodTooLong) {
                this.loadLogs();
                this.displayDatePicker = false;
            }
        }
    }
}
